import React from "react";
import { Patient } from "../../system/AppState/AppPatientsState";

type DefaultFilters = {
  isFixesRequiredOnly?: boolean;
};

type DefaultFiltersProps = {
  defaultFilters?: DefaultFilters;
};

export default function useScheduledVistsFilters(props?: DefaultFiltersProps) {
  const [isOpen, setOpen] = React.useState(false);
  const [patient, setPatient] = React.useState<Patient | null>(null);
  const [boroughs, setBoroughs] = React.useState<string[]>([]);
  const [patientSchedule, setPatientSchedule] = React.useState<string[]>([]);
  const [visitTypes, setVisitTypes] = React.useState<string[]>([]);
  const [isFixesRequiredOnly, setIsFixesRequiredOnly] = React.useState(
    props?.defaultFilters?.isFixesRequiredOnly ?? false
  );

  return {
    isOpen,
    patient,
    setPatient,
    boroughs,
    setBoroughs,
    patientSchedule,
    setPatientSchedule,
    visitTypes,
    setVisitTypes,
    isFixesRequiredOnly,
    setIsFixesRequiredOnly,
    count: [boroughs, patientSchedule, visitTypes].filter((x) => x.length > 0).length,
    open: () => setOpen(true),
    close: () => setOpen(false),
  };
}
